<template>
  <div class="container-fluid d-flex flex-column flex-grow-1 mt-3">
    <ListingComponent class="bg-white"
                      ref="activationList"
                      :addNewButton="addNewButton"
                      :requestProvider="requestProvider"
                      :columnConfig="columnConfig">
    </ListingComponent>
    <b-modal v-model="isResetModal"
             :no-close-on-backdrop="true"
             centered title="Confirmation"
             @cancel="closeResetModal"
             @ok="updateAction">
      <form>
        <h3 class="text-black-50">{{ message }}</h3>
      </form>
    </b-modal>
    <b-modal v-model="isAddNewModal"
             :no-close-on-backdrop="true"
             centered title="Add New"
             @cancel="closeAddNewModal" @ok="addNew">
      <form>
        <b-form-input v-model="newItem.phone" placeholder="998000000000" required></b-form-input>
        <b-form-input v-model="newItem.forDate" placeholder="30.06.2021" class="mt-3" required></b-form-input>
        <b-form-select v-model="selectedPhoneCompany" :options="phoneCompanies" class="mt-3" required></b-form-select>
      </form>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment'
import ListingComponent from '@/components/listing/ListingComponent'
let id = null
export default {
  name: 'ActivationListPage',
  data () {
    return {
      isResetAction: true,
      isResetModal: false,
      isAddNewModal: false,
      newItem: {
        phone: '',
        forDate: '',
        companyName: ''
      },
      selectedPhoneCompany: 'Ucell',
      phoneCompanies: [
        { value: 'Ucell', text: 'Ucell' },
        { value: 'Beeline', text: 'Beeline' }
      ],
      columnConfig: [
        {
          columnCode: 'action',
          columnName: 'Action',
          value: (item) => {
            let menuItem
            if (item.status === 'FINISHED') {
              menuItem = <b-dropdown-item onClick={() => this.showResetModal(item.id, true)}>Reset</b-dropdown-item>
            } else {
              menuItem = <b-dropdown-item onClick={() => this.showResetModal(item.id, false)}>Stop</b-dropdown-item>
            }
            return (
              <b-dropdown variant="link" class="listing-action">
                {menuItem}
              </b-dropdown>
            )
          }
        },
        {
          columnCode: 'chatId',
          columnName: 'Chat Id',
          align: 'left',
          value: item => {
            return item.chatId
          }
        },
        {
          columnCode: 'firstName',
          columnName: 'First Name',
          align: 'left',
          value: item => {
            return item.firstName
          }
        },
        {
          columnCode: 'lastName',
          columnName: 'Last Name',
          align: 'left',
          value: item => {
            return item.lastName
          }
        },
        {
          columnCode: 'phone',
          columnName: 'Phone',
          align: 'left',
          value: item => {
            return item.phone
          }
        },
        {
          columnCode: 'companyName',
          columnName: 'Company Name',
          align: 'left',
          value: item => {
            return item.companyName
          }
        },
        {
          columnCode: 'forDate',
          columnName: 'Activation for Day',
          align: 'left',
          value: item => {
            return item.forDate ? moment(item.forDate).format('YYYY-MM-DD') : ''
          }
        },
        {
          columnCode: 'actionCount',
          columnName: 'Action',
          align: 'left',
          value: item => {
            return item.action || '0'
          }
        },
        {
          columnCode: 'status',
          columnName: 'Action Status',
          align: 'left',
          value: item => {
            return item.status
          }
        },
        {
          columnCode: 'smsFirstStatus',
          columnName: 'Sms 1 Status',
          align: 'left',
          value: item => {
            return item.smsFirstStatus
          }
        },
        {
          columnCode: 'smsSecondStatus',
          columnName: 'Sms 2 Status',
          align: 'left',
          value: item => {
            return item.smsSecondStatus
          }
        },
        {
          columnCode: 'paymentStatus',
          columnName: 'Payment Status',
          align: 'left',
          value: item => {
            return item.paymentStatus
          }
        },
        {
          columnCode: 'createdDate',
          columnName: 'Created Date',
          align: 'left',
          value: item => {
            return item.createdDate ? moment(item.createdDate).format('YYYY-MM-DD HH:mm:ss') : ''
          }
        }
      ]
    }
  },
  methods: {
    requestProvider (payload) {
      return this.axios.get('sms/list', payload)
    },
    addNewButton () {
      return (<b-button class="mr-3" variant="primary" onClick={() => this.showAddNewModal()}>Add</b-button>)
    },
    showResetModal (itemId, isResetAction) {
      if (!itemId) {
        this.$toastr.error('Item not found')
      }
      id = itemId
      this.isResetAction = isResetAction
      this.isResetModal = true
    },
    closeResetModal () {
      id = null
      this.isResetAction = true
      this.isResetModal = false
    },
    showAddNewModal () {
      this.isAddNewModal = true
    },
    closeAddNewModal () {
      this.isAddNewModal = false
    },
    updateAction () {
      if (!id) {
        return
      }
      this.$loading.show()
      this.axios.put('admin-sms/activation-reset-action', {
        activationId: id,
        resetAction: this.isResetAction
      })
        .then(response => {
          this.$refs.activationList.doRequest()
          this.$loading.hide()
          if (response.data && response.data.status === 200) {
            this.$toastr.success('SMS activation saved successfully')
          }
          this.isResetModal = false
          id = null
        })
    },
    addNew () {
      const item = {...this.newItem}
      item.companyName = this.selectedPhoneCompany
      this.$loading.show()
      this.axios.post('admin-sms/activation', item)
        .then(response => {
          this.$refs.activationList.doRequest()
          this.$loading.hide()
          if (response.data && response.data.status === 200) {
            this.$toastr.success('SMS activation saved successfully')
          }
          this.newItem = {
            phone: '',
            forDate: '',
            companyName: ''
          }
          this.isAddNewModal = false
        })
    }
  },
  computed: {
    message () {
      return this.isResetAction ? 'Do you really want to reset' : 'Do you really want to stop'
    }
  },
  components: {
    ListingComponent
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/activation/ActivationListPage.vue